import { config } from 'CONFIG';
import store from '@/store';
import { isMobile, isCN } from '@/common/js/utils';

// 根据UA和语言返回对应的官网url
export function getOfficialUrl ( url ) {

    if ( url.includes( 'www.uniden.com' )) {

        return url;

    }

    let { reolink } = config;
    let pre = reolink.includes( 'https://www.' ) ? 'https://www.' : 'https://';
    let root = reolink.replace( pre, '' );
    let pathWrap = url.split( '//' )[1];
    let index = pathWrap.indexOf( '/' );
    if ( index === -1 ) {

        return reolink;

    }
    let path = pathWrap.substring( index + 1 );
    let langState = store.state.lang.lang;
    let isMFlag = isMobile() && !isCN( url ) ? 'm.' : '';
    let lang = langState === 'de' ? 'de/' : '';

    return `https://${isMFlag}${root}/${lang}${path}`;

}



// WEBPACK FOOTER //
// ./src/common/js/url.js